import axios from 'axios';
import { secureStorage } from '../utils/secureStorage';
import { BACKEND_URL } from '../utils/backendUrl';

const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with auth headers
const createAuthAxios = () => {
  const token = secureStorage.getItem('nexus_access_token');
  return axios.create({
    baseURL: API_BASE,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` })
    }
  });
};

// User Management API endpoints for Phase 3
export const userManagementApi = {
  // Approval Queue endpoints with role-based caching
  getApprovalQueue: async (userId = null, role = null) => {
    const api = createAuthAxios();
    // Include user context in query for proper caching
    const params = {};
    if (userId) params.user_id = userId;
    if (role) params.role = role;
    
    const response = await api.get('/approval/queue', { params });
    return response.data;
  },

  approvalAction: async (actionData) => {
    const api = createAuthAxios();
    const response = await api.post('/approval/act', actionData);
    return response.data;
  },

  // User Profile endpoint
  getUserProfile: async () => {
    const api = createAuthAxios();
    const response = await api.get('/approval/users/me');
    return response.data;
  },

  // User Group Assignment (Admin only)
  assignUserGroup: async (assignmentData) => {
    const api = createAuthAxios();
    const response = await api.post('/users/assign-group', assignmentData);
    return response.data;
  },

  // Analytics endpoints
  getGlobalAnalytics: async () => {
    const api = createAuthAxios();
    const response = await api.get('/analytics/global/summary');
    return response.data;
  },

  getFunctionalAnalytics: async (groupName) => {
    const api = createAuthAxios();
    const response = await api.get(`/analytics/function/${groupName}`);
    return response.data;
  },

  getManagementDashboardStats: async () => {
    const api = createAuthAxios();
    const response = await api.get('/analytics/management/dashboard');
    return response.data;
  },

  getExecutorPerformance: async () => {
    const api = createAuthAxios();
    const response = await api.get('/analytics/management/executor-performance');
    return response.data;
  },

  getVideoApprovalComparison: async () => {
    const api = createAuthAxios();
    const response = await api.get('/analytics/supervisor/video-comparison');
    return response.data;
  },

  getVideoMonthlyTrend: async () => {
    const api = createAuthAxios();
    const response = await api.get('/analytics/supervisor/video-monthly-trend');
    return response.data;
  },

  getGovernanceSummary: async () => {
    const api = createAuthAxios();
    const response = await api.get('/governance/summary');
    return response.data;
  },

  // System Health (enhanced)
  getSystemHealth: async () => {
    const api = createAuthAxios();
    const response = await api.get('/nexus/health');
    return response.data;
  }
};

export default userManagementApi;